<style>
    @import './assets/styles/style.css';
    @import 'https://fonts.googleapis.com/css?family=Montserrat:400,500,700';
</style>

<template>
    <div id="container">
        <div class="header">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6 col-sm-12">
                        <div class="logo-wrapper">
                            <a href="https://promobi.rs/">
                                <img src="./assets/img/promobi-white.svg" alt="">
                            </a>
                        </div>
                    </div>
                    <div class="col-lg-6 col-sm-12">
                        <div class="header-text-wrapper">
                            <img src="./assets/img/phone-header.svg" alt="">
                            <p class="header-text"> Call centar: 011-3555-047 | pon-pet 09:00 - 18:00; sub 09-15 </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <div id="app">
                <router-view/>
            </div>
        </div>
        <div class="footer">
           <div class="container">
               <div class="row">
                   <div class="col-lg-6 col-sm-12">
                       <a href="https://promobi.rs/">
                           <img src="./assets/img/promobi-white.svg" alt="">
                       </a>
                   </div>
                   <div class="col-lg-6 col-sm-12">
                       <div class="footer-text">
                           <p>Dijagnostika, servisiranje i popravka telekomunikacionih uređaja i opreme, pre - konfiguracija i promene softvera kao i programska podrška mobilnih telefona. ProMobi servisni centar, pored postojećeg sertifikata ISO 9001:2008, uspešno prošao eksternu proveru i serfikaciju svog Sistema za upravljanje bezbednošću informacija (ISMS) prema standardu ISO 27001:2013..</p>
                       </div>
                   </div>
               </div>
           </div>
            <div class="subfooter">
                <p>© 2019 ProMobi. Sva prava zadržana.</p>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        head:{
            title: {
             inner: 'Otkup uređaja',
             complement: 'ProMobi'
            },
            meta:[
                {  name:'author',  content:'https://viewpnt.com/' },
            ]
        }
    }

</script>


<style>
    html,body{
        background: #f2f7fa;
        font-family: 'Montserrat', sans-serif;
        margin:0;
        padding:0;
        height:100%;
    }

    #container {
        min-height:100%;
        position:relative;
    }


    #app {
        font-family: 'Montserrat', sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
        padding-bottom:180px;
    }

    .header{
        background-color: #0060a8;
        padding: 1rem 0;
    }

    .logo-wrapper img{
        width: 30%;
    }

    .header-text-wrapper{
        text-align: right;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-top: 0.6rem;
    }

    .header-text-wrapper p{
        margin-left: 0.5rem;
    }

    .header-text{
        display: inline-block;
    }

    .footer{
        position:absolute;
        bottom:0;
        width:100%;
        height:180px;
        margin-top: 2rem;
        padding-top: 2rem;
        background-color: #00355c;
    }

    .footer-text{
        color: #ffffff;
        background: #00355c;
        font-size: 0.9rem;
        line-height: 18px;
    }

    .subfooter{
        margin-top: 2rem;
        background: #00253f;
        padding: 0.5rem 0;
    }

    .subfooter p{
        color:#fff;
        text-align: center;
    }

    .navigation{
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1), 0 3px 6px rgba(0, 0, 0, 0.1);
        margin: 2rem 0;
        padding: 1rem 2rem;
        background: white;
    }

    .nav-item{
        color: #000;
        font-size: 1rem;
        text-transform: capitalize;
        text-decoration: none;
        font-weight: 500;
    }

    .nav-item .item-name{
        display: -moz-inline-box;
        color: #0061b1;
        text-decoration: underline;
        text-transform: capitalize;
    }

    .nav-item:last-child, .nav-item:last-child span{
        color:#ddd;
        text-decoration: none;
        cursor: default;
    }

    .nav-item span{
        color: black;
        margin-right: 1rem;
        text-decoration: none;
    }

    .main-wrapper {
        margin-bottom: 2rem;
        padding: 1.5rem 1rem;
        background: white;
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1), 0 3px 6px rgba(0, 0, 0, 0.1);
    }

    .phone-wrapper{
        padding: 1rem;
    }

    .phone{
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1), 0 3px 6px rgba(0, 0, 0, 0.1);
        background: #fff;
        transition: all .1s;
    }

    .phone:hover{
        cursor: pointer;
        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.08), 0 6px 6px rgba(0, 0, 0, 0.08);
        transition: all .1s;
    }

    img{
        max-width: 100%;
    }

    .phone-name p{
        text-align: center;
        text-decoration: none;
        color: #000;
        font-size: 1.2rem;
        padding: 1rem;
    }

    .phone-wrapper a{
        text-decoration: none;
    }

    .block-img-wrapper{
        padding: 1rem 0;
        text-align: center;
    }

    @media only screen and (max-width: 768px) {

        .logo-wrapper{
            text-align: center;
        }

        .header-text-wrapper{
            justify-content: center;
        }

        .header-text-wrapper p{
            font-size: 0.7rem;
            text-align: center;
        }

        .subfooter{
            font-size: 0.7rem;
            margin: 0;
        }

        .footer-text p{
            font-size: 0.7rem;
            padding: 1rem;
        }

        .footer{
            text-align: center;
        }
    }

</style>
